// covered-by: frontends/carrie/src/routes/settings/routes/knowledge-database/__tests__/memorySearch.test.ts

/**
 * How a citation elsewhere in the product opens the memory it rests on.
 *
 * By SEARCH and not by id, because there is no id both sides agree on: the
 * graph names a memory by its `node_id` ("mem_20260412_6f4515"), while the
 * memories API exposes the Mongo `_id` (`enterpriseMemory.ts` sets
 * `id: doc._id.toString()`). A deep link on either one resolves to no row on
 * the other side, so the memory's own opening words are the only handle that
 * actually finds it.
 */

/** Longest term worth sending; the panel matches a prefix perfectly well. */
const MAX_TERM = 60;

/** Below this, clipping to a word boundary would leave nothing to match on. */
const MIN_WORD_BOUNDARY = 20;

/**
 * The opening words of a memory, as something the Memories search can match.
 *
 * The label arrives clipped by warhol (`_line(..., 120)`), so it can end in an
 * ellipsis and mid-word. Both are trimmed: a search for half a word finds
 * nothing, and the ellipsis is not in the stored text.
 */
export function memorySearchTerm(label?: string): string {
  const text = (label ?? "").replace(/[….]+$/, "").trim();
  if (text.length <= MAX_TERM) return text;
  const clipped = text.slice(0, MAX_TERM);
  const lastSpace = clipped.lastIndexOf(" ");
  return (
    lastSpace > MIN_WORD_BOUNDARY ? clipped.slice(0, lastSpace) : clipped
  ).trim();
}
